import React, { Component } from 'react';
import Card from './EventCard';
import { DropTarget } from 'react-dnd';
import { bindActionCreators } from 'redux';
import * as Actions from '../store/actions';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

class Container extends Component {

    constructor(props) {
        super(props);
    }

    pushCard = (event) => {
        this.props.addUnscheduledEvent({index: 0}, {index: 0}, event.eventType, event);
    }

    removeCard(card_id, container_id) {

    }

    render() {
        const { canDrop, isOver, connectDropTarget, list } = this.props;
        let orderedList = list.sort((a, b) => a.DisplayOrder - b.DisplayOrder)
        const isActive = canDrop && isOver;
        const style = {
            width: "100%",
            minHeight: "300px",
        };

        const backgroundColor = isActive ? 'lightgreen' : '#FFF';
        return connectDropTarget(
            <div style={{ ...style, backgroundColor }}>
                {orderedList.map((card, i) => {
                    return (
                        <ListItem key={i}>
                            <ListItemIcon>
                                <b>{i + 1}</b>
                            </ListItemIcon>
                            <ListItemText>
                                <Card
                                    key={card.id}
                                    index={i}
                                    listId={this.props.id}
                                    card={card}
                                    removeCard={this.removeCard.bind(this)}
                                    handleDelete={this.props.handleUnscheduledEventDelete}
                                    moveCard={this.props.reduxMoveCard}
                                    removeEventFromCalendar={this.props.removeEventFromCalendar}
                                    prepareDisplayOrders={this.props.prepareDisplayOrders}
                                    dropToCalendar={this.props.dropToCalendar}
                                    themeForTextColor={this.props.themeForTextColor}
                                />
                            </ListItemText>
                        </ListItem>


                    );
                })}
            </div>
        );
    }
}

const cardTarget = {
    drop(props, monitor, component) {
        const sourceObj = monitor.getItem();

        props.prepareDisplayOrders()
        if (sourceObj.card) {
            // component.pushCard(sourceObj)
        } else {
            component.pushCard(sourceObj.event)
        }

        return { target: 'this is a target' }
    }
}

export default DropTarget("event", cardTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
}))(Container);


// WEBPACK FOOTER //
// src/main/content/lesson/ScheduleComponents/Container.js